export default function mutationPush(data, value) {
  data.push(value)
  return data
}
